<mat-card *ngIf="showComponent">
    <mat-card-content>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="display: flex; justify-content: space-between; flex-direction: row">
            <div class="flex-column col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div class="titleTabContent" style="text-align: center !important">
                    <label translate>M_PERS_DATA</label>
                </div>
                <div>
                    <form>
                        <mat-form-field appearance="outline">
                            <mat-label translate>EDIT_ACCOUNTS.IPT_FLD_1</mat-label>
                            <input
                                matInput
                                (ngModelChange)="isChanged($event, 'AccountName')"
                                [formControl]="accountnameControl"
                                [readonly]="amICreating()"
                                #accountKeyInput
                                lowerCase
                                required
                            />
                            <mat-error *ngIf="accountnameControl.invalid">{{ getErrorMessage() }} </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label translate>EDIT_ACCOUNTS.IPT_FLD_2</mat-label>
                            <input matInput (ngModelChange)="isChanged($event, 'FullName')" [formControl]="fullnameControl" required />
                            <mat-error *ngIf="fullnameControl.invalid">{{ getFullNameErrorMessage() }} </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Email</mat-label>
                            <input
                                matInput
                                (ngModelChange)="isChanged($event, 'Email')"
                                [formControl]="emailControl"
                                onCopy="return false"
                                onDrag="return false"
                                onDrop="return false"
                                onPaste="return false"
                                required
                            />
                            <mat-error *ngIf="emailControl.invalid">{{ getEmailErrorMessage() }} </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label translate>ACCOUNT_CREATE.VERIFY_MAIL</mat-label>
                            <input
                                matInput
                                (ngModelChange)="isChanged($event, 'VerifyEmail')"
                                [formControl]="verifyEmailControl"
                                onCopy="return false"
                                onDrag="return false"
                                onDrop="return false"
                                onPaste="return false"
                                required
                            />
                            <mat-error *ngIf="verifyEmailControl.invalid">{{ getEmailErrorMessage() }} </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" *ngIf="isDevOpsOrHigher">
                            <mat-label translate>EDIT_ACCOUNTS.IPT_FLD_5</mat-label>
                            <input
                                matInput
                                [(ngModel)]="model.ParentAccount"
                                name="ParentAccount"
                                [disabled]="true"
                                #parentAccountKeyInput
                                lowerCase
                            />
                        </mat-form-field>

                        <mat-form-field appearance="outline" *ngIf="isDevOpsOrHigher">
                            <mat-label translate>Mobile Phone Prefix</mat-label>
                            <input
                                matInput
                                (ngModelChange)="isChanged($event, 'MobilePhonePrefix')"
                                [(ngModel)]="model.MobilePhonePrefix"
                                name="MobilePhonePrefix"
                            />
                        </mat-form-field>

                        <mat-form-field appearance="outline" *ngIf="isDevOpsOrHigher">
                            <mat-label translate>Mobile Phone Nr</mat-label>
                            <input
                                matInput
                                (ngModelChange)="isChanged($event, 'MobilePhoneNr')"
                                [(ngModel)]="model.MobilePhoneNr"
                                name="MobilePhoneNr"
                            />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label translate>EDIT_ACCOUNTS.IPT_FLD_6</mat-label>
                            <input matInput (ngModelChange)="isChanged($event, 'Notes')" [(ngModel)]="model.Notes" name="Notes" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" *ngIf="isDevOpsOrHigher">
                            <mat-label translate>Private notes</mat-label>
                            <textarea
                                matInput
                                (ngModelChange)="isChanged($event, 'PrivateNotes')"
                                [(ngModel)]="model.PrivateNotes"
                                name="PrivateNotes"
                            ></textarea>
                        </mat-form-field>

                        <mat-form-field appearance="outline" *ngIf="isDevOpsOrHigher">
                            <mat-label translate>EDIT_ACCOUNTS.IPT_FLD_10</mat-label>
                            <input matInput type="number" [(ngModel)]="model.LoginFailedCount" name="LoginFailedCount" [disabled]="true" />
                        </mat-form-field>
                    </form>
                </div>
            </div>
            <div class="flex-column col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div class="titleTabContent" style="text-align: center !important">
                    <label translate>L_APP_CONFIGURATION</label>
                </div>
                <div>
                    <form>
                        <mat-form-field appearance="outline">
                            <mat-label translate>USER_FORM.COUNTRY</mat-label>
                            <mat-select
                                name="RegionalSettings"
                                (ngModelChange)="isChanged($event, 'RegionalSettings')"
                                [(ngModel)]="selectedRs"
                                (value)="(selectedRs)"
                                (selectionChange)="selectedRsChange($event)"
                            >
                                <mat-option *ngFor="let rs of regionalSettings" [value]="rs">
                                    {{ rs.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label translate>EDIT_ACCOUNTS.IPT_FLD_4</mat-label>
                            <mat-select
                                name="Language"
                                (ngModelChange)="isChanged($event, 'Language')"
                                [(ngModel)]="selectedLanguage"
                                (value)="(selectedLanguage)"
                                (selectionChange)="selectedLanguageChange($event)"
                            >
                                <mat-option *ngFor="let l of languages" [value]="l">
                                    {{ l.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <!-- <mat-form-field appearance="outline" *ngIf="isDevOpsOrHigher">
                      <mat-label translate>Creation date</mat-label>
                      <input
                        #pref
                        matInput
                        [matDatepicker]="pdpc"
                        [(ngModel)]="model.CreationDate"
                        [readonly]="true"
                        name="CreationDate"
                      />
                      <mat-datepicker #pdpc> </mat-datepicker>
                    </mat-form-field> -->

                        <mat-form-field appearance="outline">
                            <mat-label translate>EDIT_ACCOUNTS.IPT_FLD_11</mat-label>
                            <input
                                matInput
                                [min]="minDate"
                                [matDatepicker]="eD"
                                (ngModelChange)="eDateValueChange(eD)"
                                [(ngModel)]="model.ExpirationDate"
                                name="ExpirationDate"
                                readonly="true"
                            />
                            <mat-datepicker-toggle matSuffix [for]="eD"></mat-datepicker-toggle>
                            <mat-datepicker #eD disabled="false"></mat-datepicker>
                        </mat-form-field>

                        <!-- <mat-form-field appearance="outline">
                        <mat-label>Nickname</mat-label>
                        <input matInput (ngModelChange)="isChanged($event, 'NickName')"
                            [formControl]="nicknameControl" />
                    </mat-form-field>
                    <p class="color" *ngIf="errorNickName" translate>EDIT_ACCOUNTS.ERROR_NICKNAME</p> -->

                        <!-- <mat-form-field>
                                <input matInput type="number" placeholder="{{ 'EDIT_ACCOUNTS.IPT_FLD_7' | translate }}"
                                    (ngModelChange)="isChanged($event, 'CustomerId')" [(ngModel)]="model.CustomerId"
                                    name="CustomerId" [readonly]="readOnly">
                            </mat-form-field> -->

                        <mat-form-field appearance="outline">
                            <mat-label translate>EDIT_ACCOUNTS.IPT_FLD_8</mat-label>
                            <input
                                matInput
                                [min]="minDate"
                                [matDatepicker]="pED"
                                (ngModelChange)="pDateValueChange(pED)"
                                [(ngModel)]="model.PasswordExpirationDate"
                                name="PasswordExpirationDate"
                                readonly="true"
                            />
                            <mat-datepicker-toggle matSuffix [for]="pED"></mat-datepicker-toggle>
                            <mat-datepicker #pED disabled="false"></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field appearance="outline" *ngIf="isDevOpsOrHigher">
                            <mat-label translate>Password duration in days</mat-label>
                            <input
                                matInput
                                type="number"
                                (ngModelChange)="isChanged($event, 'PasswordDuration')"
                                [(ngModel)]="model.PasswordDuration"
                                name="PasswordDuration"
                            />
                        </mat-form-field>

                        <div style="display: flex; flex-direction: column; align-items: flex-start">
                            <mat-checkbox
                                [disabled]="true"
                                (ngModelChange)="isChanged($event, 'Disabled')"
                                [(ngModel)]="model.Disabled"
                                name="Disabled"
                                ><span translate>DISABLED</span>
                            </mat-checkbox>
                            <mat-checkbox [disabled]="true" [(ngModel)]="model.Confirmed" name="Confirmed" *ngIf="isDevOpsOrHigher">
                                <span translate>L_ACC_CONFIRMED</span>
                            </mat-checkbox>
                            <mat-checkbox
                                [disabled]="true"
                                (ngModelChange)="isChanged($event, 'Locked')"
                                [(ngModel)]="model.Locked"
                                name="Locked"
                                (change)="changeLock()"
                            >
                                <span translate>L_ACC_LOCKED</span>
                            </mat-checkbox>
                            <mat-checkbox
                                [disabled]="model.CannotChangePassword"
                                (ngModelChange)="isChanged($event, 'MustChangePassword')"
                                [(ngModel)]="model.MustChangePassword"
                                name="MustChangePassword"
                            >
                                <span translate>L_ACC_MUSTCNGPWD</span>
                            </mat-checkbox>
                            <mat-checkbox
                                *ngIf="isDevOpsOrHigher"
                                (ngModelChange)="isChanged($event, 'PasswordNeverExpires')"
                                [(ngModel)]="model.PasswordNeverExpires"
                                name="PasswordNeverExpires"
                                ><span translate>L_ACC_PWDNEVREXP</span>
                            </mat-checkbox>
                            <mat-checkbox
                                *ngIf="isDevOpsOrHigher"
                                [disabled]="model.MustChangePassword"
                                (ngModelChange)="isChanged($event, 'CannotChangePassword')"
                                [(ngModel)]="model.CannotChangePassword"
                                name="CannotChangePassword"
                            >
                                <span translate>L_ACC_CNTCHNGPWD</span>
                            </mat-checkbox>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <div class="divCardActionRow">
            <div>
                <button mat-flat-button class="left" color="primary" (click)="cancel()" [disabled]="nothingHasChanged()">
                    <span translate>B_CANCEL</span>
                </button>
            </div>
            <div>
                <button mat-flat-button (click)="saveAccount()" color="primary" [disabled]="!saving">
                    <span translate>B_SAVE</span>
                </button>
            </div>
        </div>
    </mat-card-actions>
</mat-card>
